import { render, staticRenderFns } from "./AdminUploadMasterForm.vue?vue&type=template&id=851a0b16&scoped=true"
import script from "./AdminUploadMasterForm.vue?vue&type=script&lang=js"
export * from "./AdminUploadMasterForm.vue?vue&type=script&lang=js"
import style0 from "./AdminUploadMasterForm.vue?vue&type=style&index=0&id=851a0b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851a0b16",
  null
  
)

export default component.exports